// logsData.ts
export const logs = [
    {
      id: 1,
      title: "Added JSON to Excel Converter",
      description:
        "A new tool to convert JSON files directly to Excel (.xlsx) format with custom column mapping.",
      date: "2025-05-15",
    },
    {
      id: 2,
      title: "Improved Encryption Tools",
      description:
        "We’ve upgraded the AES encryption tool for better security and usability.",
      date: "2025-05-10",
    },
    {
      id: 3,
      title: "Bug Fixes & Performance Updates",
      description:
        "Fixed JSON formatter rendering issue and improved load times for all tools.",
      date: "2025-05-05",
    },
  ];
  